<template>
  <transition>
    <div id="timeline-flags" v-if="showBox" :style="flagsStyle" @mouseover="overShow" @mouseout="outHide" @mousedown="stopDocument($event)">
      <div class="content-body">
        <div :class="{'sprite-flag': true, active: selectSpritesId.indexOf(sprite.id) > -1}" v-for="sprite in sprites" @click.stop="setSelect($event, sprite)">
          <div ref="cloneWrapper" v-html="sprite.getThumbnail().children()
            .css({
              // width: 'auto',
              // height: 'auto',
              maxWidth: '100%',
              maxHeight: '100%',
              transform: 'none'
            }).prop('outerHTML')">
          </div>
        </div>
      </div>
      <div class="t-triangle"></div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import handleCrop from '@/components/mixins/handleCrop';

export default {
  mixins: [handleCrop],
  data() {
    return {
      showBox: false,
      exitTime: '',
      sprites: [],
      selectSpritesId: [],
      len: 0,
      dataId: '',
      timeout: null,
      flagsData: {},
      boxStyle: {
        width: 0,
        height: 0,
        top: 0,
        left: 0
      },
      cmd: false
    };
  },
  computed: {
    ...mapGetters(["TOOL", "SelectScenes_Msg", "SelectSprites_Msg","scoll_Size"]),
    flagsStyle() {
      const style = {};
      style.width = this.boxStyle.width + "px";
      style.height = this.boxStyle.height + "px";
      style.top = this.boxStyle.top - this.scoll_Size.top + "px";
      style.left = this.boxStyle.left - this.scoll_Size.left + "px";
      return style;
    }
  },
  props: ["dataMsg", "boxDatas"],
  watch: {
    "boxDatas.firstDatas": function(val, oldval) {
      let num = Array.indexOf(this.boxDatas.firstDatas, "timelineFlag");
      this.showBox =
        num < 0 ? false : "timelineFlag" in this.dataMsg ? true : false;
      if (this.TOOL && this.showBox) {
        this.initData()
      }
    },
    SelectSprites_Msg(val, oldval) {
      this.selectSpritesId = [];
      if(this.SelectSprites_Msg.length <= 0 ) return;
      for (let j = 0; j < this.SelectSprites_Msg.length; j++) {
        this.selectSpritesId.push(this.SelectSprites_Msg[j].id)
      }
    }
  },
  mounted() {
    this.$bus.on('timelineFlag_close', (data) => {
      if(data.dataId !== this.dataId) {
        this.initData()
      }
      this.exitTime = data.exitTime;
      this.exitTimeF()
    })
    document.addEventListener('keydown', (e) => {
      if(e.keyCode == 91 || e.keyCode == 224) this.cmd = true;
    })
    document.addEventListener('keyup', (e) => {
      this.cmd = false;
    })
  },
  methods: {
    initData() {
      if(!this.dataMsg.timelineFlag) return;
      this.flagsData = this.dataMsg.timelineFlag;
      this.sprites = [].concat(this.dataMsg.timelineFlag.sprites);
      this.$nextTick(() => {
        this.$refs.cloneWrapper &&
          this.$refs.cloneWrapper.forEach((el, i) => {
            let _sprite = this.sprites[i];
            this.resizeWrapper(el, _sprite, 42);
            this.handleCrop(el, _sprite, 42);
          })
      });
      this.exitTime = this.dataMsg.timelineFlag.exitTime;
      this.dataId = this.dataMsg.timelineFlag.dataId;
      this.boxStyle.top = this.flagsData.posx;
      this.boxStyle.left = this.flagsData.posy;
      this.len = this.sprites.length;
      if(this.len <= 4) {
        this.boxStyle.width = 4 + this.len * 38;
        this.boxStyle.height = 42;
      } else {
        this.boxStyle.width = 156;
        this.boxStyle.height = 46 + parseInt(this.len/4) * 38;
      }

      this.boxStyle.top = this.flagsData.posx - this.boxStyle.height;
      this.boxStyle.left = this.flagsData.posy - this.boxStyle.width /2;
    },
    setSelect(e, sprite) {
      this.$bus.emit('spritesFlagTime', {enterTime: sprite.effect.entranceAnim.end})
      if(this.SelectScenes_Msg.nowTime > sprite.effect.exitAnim.start / 1000) {
        eve("timeline_nowTime_change", null, {nowTime: sprite.effect.exitAnim.start / 1000,  noPlay: true})
      }
      if((this.cmd || e.ctrlKey) && this.SelectSprites_Msg) {
        let copySprite = null;
        if(this.SelectSprites_Msg[0] && this.SelectSprites_Msg[0].locked) {
          this.SelectSprites_Msg[0].id === sprite.id && this.TOOL.selectSprite()
          return;
        }
        copySprite = this.SelectSprites_Msg.filter((x) => {
          return x.id !== sprite.id
        })
        // 路径动画和锁定元素不予许多选
        if(copySprite.length === this.SelectSprites_Msg.length && !copySprite[0].effect.pathAnim.end && !sprite.effect.pathAnim.end && !sprite.locked) {
          copySprite = copySprite.concat(sprite)
        }
        this.TOOL.selectSprite(copySprite)
      }else {
        this.TOOL.selectSprite([sprite])
      }
    },
    laterClose() {
      clearTimeout(this.timeout);
      this.timeout = null;
      this.timeout = setTimeout(()=>{
        clearTimeout(this.timeout);
        this.timeout = null;
        this.exitTime = ''
        this.$bus.emit('FeaturesPop_close_vue',{
          type : 1,
          name : 'timelineFlag',
        });
      },1000)
    },
    cancelClose() {
      clearTimeout(this.timeout);
      this.timeout = null;
      this.exitTime = 'none'
    },
    overShow(e) {
      this.cancelClose();
    },
    outHide(e) {
      this.laterClose()
    },
    exitTimeF() {
      if(!this.showBox) return;
      if(this.exitTime === 'none') {
        this.cancelClose()
      } else if(this.exitTime === 'now') {
        this.$bus.emit('FeaturesPop_close_vue',{
          type : 1,
          name : 'timelineFlag',
        });
      } else if(this.exitTime === 'later') {
        this.laterClose();
      }
    },
    stopDocument(e){      // 防止事件冒泡
      e.stopPropagation();
      e.preventDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
#timeline-flags {
  position: fixed;
  transition: left 0.2s ease;
}
.content-body {
  display: flex;
  height: 100%;
  padding: 4px 0 0 4px;
  flex-wrap: wrap;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px 0px #bbb;
  border-radius: 3px;
  background: #fff;
}
.sprite-flag {
  width: 34px;
  height: 34px;
  margin: 0 4px 4px 0;
  border-radius: 2px;
  background-color: #d4d6e6;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;

  > div {
    position: relative;
    display: flex;
    overflow: hidden;
    width: 100%;
    height: 100%;
    color: #fff;
    align-items: center;
    white-space: nowrap;
    justify-content: center;
  }

  &.active, &:hover{
    border-color: #5778fb;
  }
}
.t-triangle {
  position: absolute;
  left: 50%;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 8px 7px 0;
  bottom: -7px;
  margin-left: -8px;
  padding-left: 2px;
  border-top-color: #fff;

    &::before {
      position: absolute;
      content: " ";
      z-index: -1;
      height: 10px;
      width: 10px;
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
      top: -15px;
      -webkit-box-shadow: 0px 1px 4px 0px #888;
      box-shadow: 0px 1px 4px 0px #888;
    }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/timelineFlag.vue